import React, { useEffect, useMemo, useState } from 'react';
import Layout from '../components/Layout';
import { apiRequest } from '../utils/api';

interface ProxyPlatformUsage {
  platform: string;
  usageCount: number;
  lastUsedAt: string | null;
  windowStartedAt: string | null;
  windowUsageCount: number;
  failCount: number;
  lastFailedAt: string | null;
  disabledUntil: string | null;
  lastError: string | null;
  isAvailable: boolean;
  availableAt: string | null;
  secondsUntilAvailable: number;
  availabilityReason: string | null;
}

interface ProxyItem {
  id: number;
  ipVersion: string;
  proxyType: string;
  protocol: string;
  host: string;
  port: number;
  username: string | null;
  hasPassword: boolean;
  note: string | null;
  isActive: boolean;
  usageCount: number;
  lastUsedAt: string | null;
  createdAt: string;
  updatedAt: string;
  proxy: string;
  platformUsages: ProxyPlatformUsage[];
}


interface ProxySettingsState {
  staticCooldownSeconds: number;
  dynamicCooldownSeconds: number;
  dynamicMaxRequestsPerWindow: number;
  failureBaseCooldownSeconds: number;
  failureMaxCooldownSeconds: number;
}

interface ProxyFormState {
  ipVersion: string;
  proxyType: string;
  protocol: string;
  host: string;
  port: string;
  username: string;
  password: string;
  note: string;
  isActive: boolean;
  clearPassword: boolean;
}

const text = {
  title: 'Qu\u1ea3n l\u00fd Proxy',
  subtitle: 'L\u01b0u proxy chung trong database, ph\u00e2n lo\u1ea1i IPv4/IPv6 v\u00e0 xoay theo l\u1ecbch s\u1eed d\u1ee5ng c\u1ee7a t\u1eebng n\u1ec1n t\u1ea3ng.',
  reload: 'T\u1ea3i l\u1ea1i',
  totalProxy: 'T\u1ed5ng proxy',
  active: '\u0110ang ho\u1ea1t \u0111\u1ed9ng',
  activeShort: 'Ho\u1ea1t \u0111\u1ed9ng',
  inactive: '\u0110ang t\u1eaft',
  ipv4: 'IPv4',
  ipv6: 'IPv6',
  all: 'T\u1ea5t c\u1ea3',
  allIp: 'T\u1ea5t c\u1ea3 lo\u1ea1i IP',
  autoDetect: 'T\u1ef1 nh\u1eadn d\u1ea1ng',
  editProxy: 'S\u1eeda proxy',
  ipType: 'Lo\u1ea1i IP',
  proxyType: 'Lo\u1ea1i proxy',
  staticProxy: 'Proxy t\u0129nh',
  dynamicProxy: 'Proxy \u0111\u1ed9ng',
  proxySettings: 'C\u00e0i \u0111\u1eb7t xoay proxy',
  staticCooldown: 'Cooldown proxy t\u0129nh (gi\u00e2y)',
  dynamicWindow: 'Window proxy \u0111\u1ed9ng (gi\u00e2y)',
  dynamicMaxRequests: 'Request/proxy \u0111\u1ed9ng m\u1ed7i window',
  failureBaseCooldown: 'T\u1ea1m kh\u00f3a l\u1ed7i l\u1ea7n \u0111\u1ea7u (gi\u00e2y)',
  failureMaxCooldown: 'T\u1ea1m kh\u00f3a l\u1ed7i t\u1ed1i \u0111a (gi\u00e2y)',
  saveSettings: 'L\u01b0u c\u00e0i \u0111\u1eb7t',
  settingsSaved: '\u0110\u00e3 l\u01b0u c\u00e0i \u0111\u1eb7t proxy',
  settingsHelp: 'DB \u01b0u ti\u00ean h\u01a1n .env; .env ch\u1ec9 d\u00f9ng khi DB ch\u01b0a c\u00f3 c\u00e0i \u0111\u1eb7t.',
  dynamicHelp: 'Proxy \u0111\u1ed9ng l\u00e0 gateway xoay IP, \u0111\u01b0\u1ee3c d\u00f9ng nhi\u1ec1u request trong m\u1ed9t window tr\u01b0\u1edbc khi delay.',
  availableAfter: 'kh\u1ea3 d\u1ee5ng sau',
  windowUsed: 'window',
  availableNow: 'kh\u1ea3 d\u1ee5ng',
  status: 'Tr\u1ea1ng th\u00e1i',
  search: 'T\u00ecm ki\u1ebfm',
  filter: 'L\u1ecdc',
  note: 'Ghi ch\u00fa',
  platformRecent: 'N\u1ec1n t\u1ea3ng g\u1ea7n \u0111\u00e2y',
  used: '\u0110\u00e3 d\u00f9ng',
  lastUsed: 'D\u00f9ng g\u1ea7n nh\u1ea5t',
  actions: 'Thao t\u00e1c',
  loading: '\u0110ang t\u1ea3i proxy...',
  empty: 'Ch\u01b0a c\u00f3 proxy trong DB.',
  edit: 'S\u1eeda',
  turnOff: 'T\u1eaft',
  turnOn: 'B\u1eadt',
  delete: 'X\u00f3a',
  cancelEdit: 'H\u1ee7y s\u1eeda',
  saving: '\u0110ang l\u01b0u...',
  save: 'L\u01b0u proxy',
  bulkAdd: 'Th\u00eam proxy h\u00e0ng lo\u1ea1t',
  bulkHelp: 'D\u00e1n m\u1ed9t d\u00f2ng \u0111\u1ec3 th\u00eam 1 proxy, ho\u1eb7c nhi\u1ec1u d\u00f2ng \u0111\u1ec3 th\u00eam h\u00e0ng lo\u1ea1t. H\u1ed7 tr\u1ee3 IP:PORT, [IPv6]:PORT, IP:PORT:USER:PASS, ho\u1eb7c URL c\u00f3 protocol.',
  importing: '\u0110ang import...',
  importProxy: 'Import proxy',
  noRecentUsage: 'Ch\u01b0a d\u00f9ng cho n\u1ec1n t\u1ea3ng n\u00e0o',
  neverUsed: 'Ch\u01b0a d\u00f9ng',
  disabled: 't\u1ea1m kh\u00f3a',
  previousPage: 'Trang tr\u01b0\u1edbc',
  nextPage: 'Trang sau',
  page: 'Trang',
  filtered: 'proxy theo b\u1ed9 l\u1ecdc',
  hasPassword: 'Proxy n\u00e0y \u0111ang c\u00f3 m\u1eadt kh\u1ea9u. \u0110\u1ec3 tr\u1ed1ng \u00f4 m\u1eadt kh\u1ea9u n\u1ebfu mu\u1ed1n gi\u1eef nguy\u00ean.',
  usernamePlaceholder: 'B\u1ecf tr\u1ed1ng n\u1ebfu kh\u00f4ng c\u00f3',
  passwordPlaceholder: '\u0110\u1ec3 tr\u1ed1ng \u0111\u1ec3 gi\u1eef nguy\u00ean',
  notePlaceholder: 'Nh\u00e0 cung c\u1ea5p, g\u00f3i proxy, qu\u1ed1c gia...',
  searchPlaceholder: 'Host, username, ghi ch\u00fa',
  clearOldPassword: 'X\u00f3a m\u1eadt kh\u1ea9u c\u0169',
  chooseEdit: 'H\u00e3y ch\u1ecdn proxy trong b\u1ea3ng \u0111\u1ec3 s\u1eeda. Th\u00eam m\u1edbi d\u00f9ng ph\u1ea7n import b\u00ean d\u01b0\u1edbi.',
  hostPortRequired: 'Host v\u00e0 port l\u00e0 b\u1eaft bu\u1ed9c',
  loadError: 'Kh\u00f4ng th\u1ec3 t\u1ea3i danh s\u00e1ch proxy',
  loadSettingsError: 'Kh\u00f4ng th\u1ec3 t\u1ea3i c\u00e0i \u0111\u1eb7t proxy',
  saveSettingsError: 'Kh\u00f4ng th\u1ec3 l\u01b0u c\u00e0i \u0111\u1eb7t proxy',
  saveError: 'Kh\u00f4ng th\u1ec3 l\u01b0u proxy',
  toggleError: 'Kh\u00f4ng th\u1ec3 \u0111\u1ed5i tr\u1ea1ng th\u00e1i proxy',
  deleteError: 'Kh\u00f4ng th\u1ec3 x\u00f3a proxy',
  importEmpty: 'N\u1ed9i dung import \u0111ang tr\u1ed1ng',
  importError: 'Kh\u00f4ng th\u1ec3 import proxy',
  imported: '\u0110\u00e3 import',
  skipped: 'b\u1ecf qua',
  failed: 'l\u1ed7i',
  deleteConfirm: 'X\u00f3a proxy '
};

const ipVersionOptions = [
  { value: 'ipv4', label: text.ipv4 },
  { value: 'ipv6', label: text.ipv6 }
];

const importIpVersionOptions = [
  { value: 'auto', label: text.autoDetect },
  ...ipVersionOptions
];

const proxyTypeOptions = [
  { value: 'static', label: text.staticProxy },
  { value: 'dynamic', label: text.dynamicProxy }
];

const protocolOptions = ['http', 'https', 'socks4', 'socks5'];
const importPlaceholder = [
  'rotate251.psun.io.vn:30184:user30184:2UTGQH1r',
  '103.56.161.67:8080:user:pass',
  '[2001:db8::1]:8080:user:pass',
  'http://user:pass@103.56.161.68:8080',
  'socks5://user:pass@[2001:db8::2]:1080'
].join('\n');

const defaultProxySettings: ProxySettingsState = {
  staticCooldownSeconds: 600,
  dynamicCooldownSeconds: 600,
  dynamicMaxRequestsPerWindow: 10,
  failureBaseCooldownSeconds: 300,
  failureMaxCooldownSeconds: 3600
};

const emptyForm: ProxyFormState = {
  ipVersion: 'ipv4',
  proxyType: 'static',
  protocol: 'http',
  host: '',
  port: '',
  username: '',
  password: '',
  note: '',
  isActive: true,
  clearPassword: false
};

const buttonBase: React.CSSProperties = {
  border: '1px solid #d1d5db',
  borderRadius: '6px',
  padding: '8px 12px',
  cursor: 'pointer',
  fontWeight: 600,
  background: '#fff',
  color: '#111827'
};

const primaryButton: React.CSSProperties = {
  ...buttonBase,
  borderColor: '#2563eb',
  background: '#2563eb',
  color: '#fff'
};

const dangerButton: React.CSSProperties = {
  ...buttonBase,
  borderColor: '#fecaca',
  background: '#fee2e2',
  color: '#991b1b'
};

const inputStyle: React.CSSProperties = {
  width: '100%',
  border: '1px solid #d1d5db',
  borderRadius: '6px',
  padding: '9px 10px',
  fontSize: '14px',
  minHeight: '38px',
  boxSizing: 'border-box'
};

function formatDate(value: string | null) {
  if (!value) return text.neverUsed;
  return new Date(value).toLocaleString('vi-VN');
}

function getErrorMessage(error: unknown, fallback: string) {
  return error instanceof Error ? error.message : fallback;
}

function secondsUntilTime(value: string | null, nowTick: number) {
  if (!value) return 0;
  return Math.max(0, Math.ceil((new Date(value).getTime() - nowTick) / 1000));
}

function formatDuration(seconds: number) {
  const safeSeconds = Math.max(0, Math.ceil(seconds));
  if (safeSeconds < 60) return safeSeconds + 's';
  const minutes = Math.floor(safeSeconds / 60);
  const remainSeconds = safeSeconds % 60;
  if (minutes < 60) return minutes + 'm ' + remainSeconds + 's';
  const hours = Math.floor(minutes / 60);
  const remainMinutes = minutes % 60;
  return hours + 'h ' + remainMinutes + 'm';
}

function formatUsageSummary(
  usages: ProxyPlatformUsage[],
  proxyType: string,
  settings: ProxySettingsState,
  nowTick: number
) {
  if (!usages.length) return text.noRecentUsage;
  return usages.slice(0, 3).map(usage => {
    const disabledSeconds = secondsUntilTime(usage.disabledUntil, nowTick);
    const availableSeconds = disabledSeconds > 0
      ? disabledSeconds
      : secondsUntilTime(usage.availableAt, nowTick);
    const parts = [usage.platform + ': ' + formatDate(usage.lastUsedAt)];
    if (disabledSeconds > 0) {
      parts.push(text.disabled + ', ' + text.availableAfter + ' ' + formatDuration(disabledSeconds));
    } else if (availableSeconds > 0) {
      parts.push(text.availableAfter + ' ' + formatDuration(availableSeconds));
    } else if (proxyType === 'dynamic' && usage.windowStartedAt) {
      parts.push(text.windowUsed + ' ' + usage.windowUsageCount + '/' + settings.dynamicMaxRequestsPerWindow);
    } else {
      parts.push(text.availableNow);
    }
    return parts.join(' (') + (parts.length > 1 ? ')' : '');
  }).join('\n');
}

const ProxyManagement: React.FC = () => {
  const [proxies, setProxies] = useState<ProxyItem[]>([]);
  const [stats, setStats] = useState({ total: 0, active: 0, inactive: 0, ipv4: 0, ipv6: 0 });
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [editingId, setEditingId] = useState<number | null>(null);
  const [form, setForm] = useState<ProxyFormState>(emptyForm);
  const [filterIpVersion, setFilterIpVersion] = useState('all');
  const [filterStatus, setFilterStatus] = useState('all');
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState({ page: 1, pages: 1, total: 0, hasNext: false });
  const [settings, setSettings] = useState<ProxySettingsState>(defaultProxySettings);
  const [settingsSaving, setSettingsSaving] = useState(false);
  const [nowTick, setNowTick] = useState(Date.now());
  const [importIpVersion, setImportIpVersion] = useState('auto');
  const [importProxyType, setImportProxyType] = useState('static');
  const [importContent, setImportContent] = useState('');
  const [importing, setImporting] = useState(false);

  const isEditing = editingId !== null;

  const selectedProxy = useMemo(
    () => proxies.find(item => item.id === editingId) || null,
    [editingId, proxies]
  );
  const loadSettings = async () => {
    try {
      const response = await apiRequest('/api/proxies/settings');
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.error || text.loadSettingsError);
      }
      setSettings({ ...defaultProxySettings, ...(data.data || {}) });
    } catch (error) {
      alert(getErrorMessage(error, text.loadSettingsError));
    }
  };

  const saveSettings = async () => {
    try {
      setSettingsSaving(true);
      const response = await apiRequest('/api/proxies/settings', {
        method: 'PUT',
        body: JSON.stringify(settings)
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.error || text.saveSettingsError);
      }
      setSettings({ ...defaultProxySettings, ...(data.data || {}) });
      alert(text.settingsSaved);
      await loadProxies(page);
    } catch (error) {
      alert(getErrorMessage(error, text.saveSettingsError));
    } finally {
      setSettingsSaving(false);
    }
  };

  const updateSetting = (key: keyof ProxySettingsState, value: string) => {
    const parsed = parseInt(value, 10);
    setSettings(prev => ({ ...prev, [key]: Number.isFinite(parsed) ? parsed : 0 }));
  };

  const loadProxies = async (nextPage = page) => {
    try {
      setLoading(true);
      const params = new URLSearchParams({
        page: String(nextPage),
        limit: '50',
        ipVersion: filterIpVersion,
        status: filterStatus
      });
      if (search.trim()) params.set('search', search.trim());

      const response = await apiRequest('/api/proxies?' + params.toString());
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.error || text.loadError);
      }

      setProxies(data.data || []);
      setStats(data.stats || { total: 0, active: 0, inactive: 0, ipv4: 0, ipv6: 0 });
      setPagination(data.pagination || { page: nextPage, pages: 1, total: 0, hasNext: false });
      setPage(nextPage);
    } catch (error) {
      alert(getErrorMessage(error, text.loadError));
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    loadSettings();
    const timer = window.setInterval(() => setNowTick(Date.now()), 1000);
    return () => window.clearInterval(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    loadProxies(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterIpVersion, filterStatus]);

  const resetForm = () => {
    setEditingId(null);
    setForm(emptyForm);
  };

  const startEdit = (item: ProxyItem) => {
    setEditingId(item.id);
    setForm({
      ipVersion: item.ipVersion || 'ipv4',
      proxyType: item.proxyType || 'static',
      protocol: item.protocol,
      host: item.host,
      port: String(item.port),
      username: item.username || '',
      password: '',
      note: item.note || '',
      isActive: item.isActive,
      clearPassword: false
    });
  };

  const submitProxy = async () => {
    if (!isEditing || editingId === null) {
      alert(text.chooseEdit);
      return;
    }

    if (!form.host.trim() || !form.port.trim()) {
      alert(text.hostPortRequired);
      return;
    }

    const payload: Record<string, unknown> = {
      ipVersion: form.ipVersion,
      proxyType: form.proxyType,
      protocol: form.protocol,
      host: form.host.trim(),
      port: Number(form.port),
      username: form.username.trim(),
      note: form.note.trim(),
      isActive: form.isActive
    };

    if (form.password.trim()) {
      payload.password = form.password.trim();
    }
    if (form.clearPassword) {
      payload.clearPassword = true;
    }

    try {
      setSaving(true);
      const response = await apiRequest('/api/proxies/' + editingId, {
        method: 'PUT',
        body: JSON.stringify(payload)
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.error || text.saveError);
      }

      resetForm();
      await loadProxies(page);
    } catch (error) {
      alert(getErrorMessage(error, text.saveError));
    } finally {
      setSaving(false);
    }
  };

  const toggleProxy = async (item: ProxyItem) => {
    try {
      const response = await apiRequest('/api/proxies/' + item.id, {
        method: 'PUT',
        body: JSON.stringify({ isActive: !item.isActive })
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || text.toggleError);
      await loadProxies(page);
    } catch (error) {
      alert(getErrorMessage(error, text.toggleError));
    }
  };

  const deleteProxy = async (item: ProxyItem) => {
    if (!window.confirm(text.deleteConfirm + item.proxy + '?')) return;

    try {
      const response = await apiRequest('/api/proxies/' + item.id, { method: 'DELETE' });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || text.deleteError);
      await loadProxies(page);
      if (editingId === item.id) resetForm();
    } catch (error) {
      alert(getErrorMessage(error, text.deleteError));
    }
  };

  const importProxies = async () => {
    if (!importContent.trim()) {
      alert(text.importEmpty);
      return;
    }

    try {
      setImporting(true);
      const response = await apiRequest('/api/proxies/import', {
        method: 'POST',
        body: JSON.stringify({ ipVersion: importIpVersion, proxyType: importProxyType, content: importContent })
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || text.importError);

      const errorLines = Array.isArray(data.errors) ? data.errors.slice(0, 10) : [];
      const moreErrors = Array.isArray(data.errors) && data.errors.length > errorLines.length
        ? '\n... c\u00f2n ' + (data.errors.length - errorLines.length) + ' l\u1ed7i n\u1eefa'
        : '';
      const errorDetails = errorLines.length > 0 ? '\n\n' + errorLines.join('\n') + moreErrors : '';
      alert(text.imported + ' ' + (data.created || 0) + ' proxy, ' + text.skipped + ' ' + (data.skipped || 0) + ', ' + text.failed + ' ' + (data.failed || 0) + errorDetails);
      setImportContent('');
      await loadProxies(1);
    } catch (error) {
      alert(getErrorMessage(error, text.importError));
    } finally {
      setImporting(false);
    }
  };

  return (
    <Layout>
      <div style={{ color: '#111827', width: '100%', maxWidth: '100%', overflowX: 'hidden', boxSizing: 'border-box' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '20px', gap: '12px', flexWrap: 'wrap' }}>
          <div>
            <h1 style={{ margin: 0, fontSize: '28px' }}>{text.title}</h1>
            <p style={{ margin: '6px 0 0', color: '#6b7280' }}>{text.subtitle}</p>
          </div>
          <button onClick={() => loadProxies(page)} disabled={loading} style={buttonBase}>{text.reload}</button>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(170px, 1fr))', gap: '12px', marginBottom: '18px' }}>
          {[
            [text.totalProxy, stats.total, '#111827'],
            [text.active, stats.active, '#047857'],
            [text.inactive, stats.inactive, '#b91c1c'],
            [text.ipv4, stats.ipv4, '#1d4ed8'],
            [text.ipv6, stats.ipv6, '#7c3aed']
          ].map(([label, value, color]) => (
            <div key={String(label)} style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: '8px', padding: '14px', minWidth: 0 }}>
              <div style={{ color: '#6b7280', fontSize: '13px' }}>{label}</div>
              <div style={{ fontSize: '26px', fontWeight: 700, color: String(color) }}>{value}</div>
            </div>
          ))}
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 430px), 1fr))', gap: '18px', alignItems: 'start' }}>
          <div style={{ display: 'grid', gap: '18px', minWidth: 0 }}>
            {isEditing && (
              <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: '8px', padding: '16px', minWidth: 0, boxSizing: 'border-box' }}>
                <h2 style={{ margin: '0 0 14px', fontSize: '20px' }}>{text.editProxy}</h2>
                {selectedProxy?.hasPassword && (
                  <div style={{ marginBottom: '12px', padding: '10px', background: '#f9fafb', borderRadius: '6px', color: '#4b5563', fontSize: '13px' }}>
                    {text.hasPassword}
                  </div>
                )}

                <div style={{ display: 'grid', gap: '12px' }}>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '10px' }}>
                    <label>
                      <div style={{ marginBottom: '5px', fontWeight: 600 }}>{text.ipType}</div>
                      <select value={form.ipVersion} onChange={e => setForm({ ...form, ipVersion: e.target.value })} style={inputStyle}>
                        {ipVersionOptions.map(option => <option key={option.value} value={option.value}>{option.label}</option>)}
                      </select>
                    </label>
                    <label>
                      <div style={{ marginBottom: '5px', fontWeight: 600 }}>{text.proxyType}</div>
                      <select value={form.proxyType} onChange={e => setForm({ ...form, proxyType: e.target.value })} style={inputStyle}>
                        {proxyTypeOptions.map(option => <option key={option.value} value={option.value}>{option.label}</option>)}
                      </select>
                    </label>
                  </div>

                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))', gap: '10px' }}>
                    <label>
                      <div style={{ marginBottom: '5px', fontWeight: 600 }}>Protocol</div>
                      <select value={form.protocol} onChange={e => setForm({ ...form, protocol: e.target.value })} style={inputStyle}>
                        {protocolOptions.map(protocol => <option key={protocol} value={protocol}>{protocol}</option>)}
                      </select>
                    </label>
                    <label>
                      <div style={{ marginBottom: '5px', fontWeight: 600 }}>Host / IP</div>
                      <input value={form.host} onChange={e => setForm({ ...form, host: e.target.value })} placeholder="103.56.161.67" style={inputStyle} />
                    </label>
                    <label>
                      <div style={{ marginBottom: '5px', fontWeight: 600 }}>Port</div>
                      <input value={form.port} onChange={e => setForm({ ...form, port: e.target.value })} placeholder="8080" style={inputStyle} />
                    </label>
                  </div>

                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '10px' }}>
                    <label>
                      <div style={{ marginBottom: '5px', fontWeight: 600 }}>Username</div>
                      <input value={form.username} onChange={e => setForm({ ...form, username: e.target.value })} placeholder={text.usernamePlaceholder} style={inputStyle} />
                    </label>
                    <label>
                      <div style={{ marginBottom: '5px', fontWeight: 600 }}>Password</div>
                      <input value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} type="password" placeholder={text.passwordPlaceholder} style={inputStyle} />
                    </label>
                  </div>

                  <label>
                    <div style={{ marginBottom: '5px', fontWeight: 600 }}>{text.note}</div>
                    <input value={form.note} onChange={e => setForm({ ...form, note: e.target.value })} placeholder={text.notePlaceholder} style={inputStyle} />
                  </label>

                  <div style={{ display: 'flex', gap: '14px', alignItems: 'center', flexWrap: 'wrap' }}>
                    <label style={{ display: 'flex', gap: '8px', alignItems: 'center', fontWeight: 600 }}>
                      <input type="checkbox" checked={form.isActive} onChange={e => setForm({ ...form, isActive: e.target.checked })} />
                      {text.active}
                    </label>
                    {selectedProxy?.hasPassword && (
                      <label style={{ display: 'flex', gap: '8px', alignItems: 'center', fontWeight: 600 }}>
                        <input type="checkbox" checked={form.clearPassword} onChange={e => setForm({ ...form, clearPassword: e.target.checked })} />
                        {text.clearOldPassword}
                      </label>
                    )}
                  </div>

                  <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '4px' }}>
                    <button onClick={resetForm} style={buttonBase}>{text.cancelEdit}</button>
                    <button onClick={submitProxy} disabled={saving} style={primaryButton}>{saving ? text.saving : text.save}</button>
                  </div>
                </div>
              </div>
            )}
            <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: '8px', padding: '16px', minWidth: 0, boxSizing: 'border-box' }}>
              <h2 style={{ margin: '0 0 8px', fontSize: '20px' }}>{text.proxySettings}</h2>
              <div style={{ marginBottom: '12px', color: '#6b7280', fontSize: '13px' }}>{text.settingsHelp}</div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(170px, 1fr))', gap: '10px' }}>
                <label>
                  <div style={{ marginBottom: '5px', fontWeight: 600 }}>{text.staticCooldown}</div>
                  <input type="number" min="0" value={settings.staticCooldownSeconds} onChange={e => updateSetting('staticCooldownSeconds', e.target.value)} style={inputStyle} />
                </label>
                <label>
                  <div style={{ marginBottom: '5px', fontWeight: 600 }}>{text.dynamicWindow}</div>
                  <input type="number" min="0" value={settings.dynamicCooldownSeconds} onChange={e => updateSetting('dynamicCooldownSeconds', e.target.value)} style={inputStyle} />
                </label>
                <label>
                  <div style={{ marginBottom: '5px', fontWeight: 600 }}>{text.dynamicMaxRequests}</div>
                  <input type="number" min="1" value={settings.dynamicMaxRequestsPerWindow} onChange={e => updateSetting('dynamicMaxRequestsPerWindow', e.target.value)} style={inputStyle} />
                </label>
                <label>
                  <div style={{ marginBottom: '5px', fontWeight: 600 }}>{text.failureBaseCooldown}</div>
                  <input type="number" min="1" value={settings.failureBaseCooldownSeconds} onChange={e => updateSetting('failureBaseCooldownSeconds', e.target.value)} style={inputStyle} />
                </label>
                <label>
                  <div style={{ marginBottom: '5px', fontWeight: 600 }}>{text.failureMaxCooldown}</div>
                  <input type="number" min="1" value={settings.failureMaxCooldownSeconds} onChange={e => updateSetting('failureMaxCooldownSeconds', e.target.value)} style={inputStyle} />
                </label>
              </div>
              <div style={{ marginTop: '10px', color: '#6b7280', fontSize: '13px' }}>{text.dynamicHelp}</div>
              <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '12px' }}>
                <button onClick={saveSettings} disabled={settingsSaving} style={primaryButton}>{settingsSaving ? text.saving : text.saveSettings}</button>
              </div>
            </div>


            <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: '8px', padding: '16px', minWidth: 0, boxSizing: 'border-box' }}>
              <h2 style={{ margin: '0 0 10px', fontSize: '20px' }}>{text.bulkAdd}</h2>
              <div style={{ marginBottom: '10px', color: '#6b7280', fontSize: '13px' }}>{text.bulkHelp}</div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '10px', marginBottom: '10px' }}>
                <label>
                  <div style={{ marginBottom: '5px', fontWeight: 600 }}>{text.ipType}</div>
                  <select value={importIpVersion} onChange={e => setImportIpVersion(e.target.value)} style={inputStyle}>
                    {importIpVersionOptions.map(option => <option key={option.value} value={option.value}>{option.label}</option>)}
                  </select>
                </label>
                <label>
                  <div style={{ marginBottom: '5px', fontWeight: 600 }}>{text.proxyType}</div>
                  <select value={importProxyType} onChange={e => setImportProxyType(e.target.value)} style={inputStyle}>
                    {proxyTypeOptions.map(option => <option key={option.value} value={option.value}>{option.label}</option>)}
                  </select>
                </label>
              </div>
              <textarea
                value={importContent}
                onChange={e => setImportContent(e.target.value)}
                placeholder={importPlaceholder}
                style={{ ...inputStyle, minHeight: '170px', resize: 'vertical', fontFamily: 'monospace', lineHeight: 1.5 }}
              />
              <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
                <button onClick={importProxies} disabled={importing} style={primaryButton}>{importing ? text.importing : text.importProxy}</button>
              </div>
            </div>
          </div>

          <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: '8px', overflow: 'hidden', minWidth: 0, maxWidth: '100%' }}>
            <div style={{ padding: '14px', borderBottom: '1px solid #e5e7eb', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: '10px', alignItems: 'end' }}>
              <label>
                <div style={{ marginBottom: '5px', fontWeight: 600 }}>{text.ipType}</div>
                <select value={filterIpVersion} onChange={e => setFilterIpVersion(e.target.value)} style={inputStyle}>
                  <option value="all">{text.allIp}</option>
                  {ipVersionOptions.map(option => <option key={option.value} value={option.value}>{option.label}</option>)}
                </select>
              </label>
              <label>
                <div style={{ marginBottom: '5px', fontWeight: 600 }}>{text.status}</div>
                <select value={filterStatus} onChange={e => setFilterStatus(e.target.value)} style={inputStyle}>
                  <option value="all">{text.all}</option>
                  <option value="active">{text.activeShort}</option>
                  <option value="inactive">{text.inactive}</option>
                </select>
              </label>
              <label>
                <div style={{ marginBottom: '5px', fontWeight: 600 }}>{text.search}</div>
                <input value={search} onChange={e => setSearch(e.target.value)} onKeyDown={e => e.key === 'Enter' && loadProxies(1)} placeholder={text.searchPlaceholder} style={inputStyle} />
              </label>
              <button onClick={() => loadProxies(1)} disabled={loading} style={primaryButton}>{text.filter}</button>
            </div>

            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: '1120px' }}>
                <thead style={{ background: '#f9fafb' }}>
                  <tr>
                    {['Proxy', text.proxyType, text.ipType, text.status, text.used, text.lastUsed, text.platformRecent, text.note, text.actions].map(header => (
                      <th key={header} style={{ textAlign: 'left', padding: '11px 12px', fontSize: '12px', color: '#6b7280', borderBottom: '1px solid #e5e7eb' }}>{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr><td colSpan={9} style={{ padding: '28px', textAlign: 'center', color: '#6b7280' }}>{text.loading}</td></tr>
                  ) : proxies.length === 0 ? (
                    <tr><td colSpan={9} style={{ padding: '28px', textAlign: 'center', color: '#6b7280' }}>{text.empty}</td></tr>
                  ) : proxies.map(item => (
                    <tr key={item.id} style={{ borderBottom: '1px solid #f3f4f6' }}>
                      <td style={{ padding: '12px', fontFamily: 'monospace', fontSize: '13px', overflowWrap: 'anywhere', minWidth: '220px' }}>{item.proxy}</td>
                      <td style={{ padding: '12px' }}><span style={{ padding: '4px 8px', borderRadius: '999px', background: item.proxyType === 'dynamic' ? '#ede9fe' : '#f3f4f6', color: item.proxyType === 'dynamic' ? '#5b21b6' : '#374151', fontWeight: 700, fontSize: '12px' }}>{item.proxyType === 'dynamic' ? text.dynamicProxy : text.staticProxy}</span></td>
                      <td style={{ padding: '12px', textTransform: 'uppercase', fontWeight: 700 }}>{item.ipVersion}</td>
                      <td style={{ padding: '12px' }}>
                        <span style={{ padding: '4px 8px', borderRadius: '999px', background: item.isActive ? '#dcfce7' : '#fee2e2', color: item.isActive ? '#166534' : '#991b1b', fontWeight: 700, fontSize: '12px' }}>
                          {item.isActive ? text.activeShort : text.inactive}
                        </span>
                      </td>
                      <td style={{ padding: '12px' }}>{item.usageCount}</td>
                      <td style={{ padding: '12px', color: '#4b5563', whiteSpace: 'nowrap' }}>{formatDate(item.lastUsedAt)}</td>
                      <td style={{ padding: '12px', color: '#4b5563', whiteSpace: 'pre-line', minWidth: '160px' }}>{formatUsageSummary(item.platformUsages || [], item.proxyType || 'static', settings, nowTick)}</td>
                      <td style={{ padding: '12px', color: '#4b5563' }}>{item.note || '-'}</td>
                      <td style={{ padding: '12px' }}>
                        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                          <button onClick={() => startEdit(item)} style={buttonBase}>{text.edit}</button>
                          <button onClick={() => toggleProxy(item)} style={buttonBase}>{item.isActive ? text.turnOff : text.turnOn}</button>
                          <button onClick={() => deleteProxy(item)} style={dangerButton}>{text.delete}</button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div style={{ padding: '12px 14px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', color: '#6b7280', fontSize: '13px', gap: '10px', flexWrap: 'wrap' }}>
              <div>{text.page} {pagination.page} / {Math.max(pagination.pages, 1)} - {pagination.total} {text.filtered}</div>
              <div style={{ display: 'flex', gap: '8px' }}>
                <button disabled={page <= 1} onClick={() => loadProxies(page - 1)} style={{ ...buttonBase, opacity: page <= 1 ? 0.5 : 1 }}>{text.previousPage}</button>
                <button disabled={!pagination.hasNext} onClick={() => loadProxies(page + 1)} style={{ ...buttonBase, opacity: !pagination.hasNext ? 0.5 : 1 }}>{text.nextPage}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ProxyManagement;
